import PageHero from "../../Component/PageHero/PageHero";
import styles from "../../styles/pages/shipping/shipping.module.scss";
import { Col, message, Row, Skeleton, Image, Result } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Api from "../../Network/ApiConfig";
import { useHistory } from "react-router-dom";
import { setUserOrder } from "../../redux/cart/cart.action";
import { fallbackImg } from "../../public/constants";
import img_1Img from "../../images/Group 25847.svg";
import { setSettings } from "../../redux/user/user.action";
import en from "../../localization/en";

function OrderCompany() {
    const t = en;
  const { order } = useSelector((state) => state?.cart);
  const { Settings } = useSelector((state) => state?.user);
  const [companyList, setcompanyList] = useState([]);
  const [companyActive, setcompanyActive] = useState(null);
  const [loading, setloading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentLang } = useSelector((state) => state?.user);

  useEffect(() => {
    setloading(true);
    console.log("orrder", order);

    Api.get(
      `AdminAPIs/GetDeliveryCompanies?FromCustomerAddressId=${order?.FromCustomerAddressId}&ToCustomerAddressId=${order?.ToCustomerAddressId}&PackgeSizeId=${order?.PackgeSizeId}&DeliveryTypeId=${order.ServiceDeliveryTypeId}&CategoryId=${order.CategoryId}`
    ).then(
      (res) => {
        setloading(false);
        console.log(res);
        setcompanyList(res?.data?.model || []);
      },
      (err) => {
        console.log(err);
        setloading(false);
        setcompanyList([]);
        // message.error(err?.message);
      }
    );
    if (order) {
      setcompanyActive(order?.CompanyPackgeSizeId || null);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Api.get("MetaData/GetSettings");
        dispatch(setSettings(response?.data?.model));
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const handelSetDeliveryCompany = (company) => {
    setcompanyActive(company?.Id);
    let vatCost;
    if (order?.ServiceId === 1) {
      vatCost = +company?.Price * (+Settings?.[1]?.SettingValue || 0.05);
    } else {
      vatCost = +company?.Price * (+Settings?.[1]?.SettingValue || 0.05);
      // vatCost = +order?.VAT
    }
    dispatch(
      setUserOrder({
        ...order,
        VAT: vatCost?.toFixed(2) || vatCost,
        CompanyPackgeSizeId: company?.Id,
        DeliveryCompany: company,
        DeliveryCost: company?.Price,
        Total: company?.Price + +vatCost,
      })
    );
    setTimeout(() => {
      history.push("/add-order-info");
    }, 500);
  };

  useEffect(() => {
    const body = document.querySelector("#root");
    body?.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <PageHero
        title={+order?.ServiceId === 1 ? t.delivery : t.PersonalShopper}
      />
      <div className={styles.shipping_page}>
        <div className="container">
          <div
            className={styles.shipping_page_holder + " shipping_page_holder"}
          >
            {loading ? (
              <>
                <Skeleton avatar active paragraph={{ rows: 3 }} />
                <Skeleton avatar active paragraph={{ rows: 3 }} />
                <Skeleton avatar active paragraph={{ rows: 3 }} />
              </>
            ) : (
              <>
                {companyList?.length === 0 && (
                  <Result
                    status="403"
                    // icon={}
                    title={t.nocompanyfound}
                    //   extra={
                    //   <Button type="primary"
                    //   className="btn-primary fw"
                    //   style={{ marginTop: "7rem" }}
                    //   onClick={() => setIsModuleVisible(true)}
                    // >
                    //   {t.SendSMS}
                    // </Button>
                    // }
                    style={{ marginTop: "6rem" }}
                  />
                )}
                <ul className={styles.shipping_list}>
                  {companyList?.map((s) => (
                    <li
                      key={s?.id}
                      onClick={() => handelSetDeliveryCompany(s)}
                      className={`${
                        companyActive === s?.Id && "company-active"
                      }`}
                    >
                      <Row gutter={40} justify="space-between">
                        <Col xs={18}>
                          <div className={styles.item_info}>
                            <div className={styles.image_holder}>
                              <Image
                                src={s?.Image || img_1Img}
                                layout="fill"
                                maxWidth="170rem"
                                minWidth="10rem"
                                alt="company logo"
                                preview={false}
                                fallback={fallbackImg}
                              />
                            </div>
                            <div className={styles.text_holder}>
                              <h2>
                                {currentLang === "en" ? s?.Name : s?.NameLT}
                              </h2>
                              <p>
                                {currentLang === "en"
                                  ? s?.Description
                                  : s?.DescriptionLT}
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col xs={6}>
                          <div className={styles.item_price}>
                            <span>{s?.Price}</span>
                            {t.SAR}
                          </div>
                        </Col>
                      </Row>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderCompany;
